import * as React from 'react'
import styled, { css } from 'styled-components'

import { t } from '@owl-nest/localize'
import * as model from '@owl-nest/models'
import * as plume from '@ulule/owl-kit-components/next'
import * as env from '@owl-nest/config'

import * as projectModel from '../../../../models/project'

type ProjectFinancedPropTypes = {
  project: projectModel.Project
  fullSize: boolean
}

export function ProjectFinanced({
  project,
  fullSize,
}: ProjectFinancedPropTypes): React.ReactElement<ProjectFinancedPropTypes> {
  const userConfig = env.useUserEnv()

  return (
    <ProjectFinancedContainer fullSize={fullSize}>
      <InformationContainer fullSize={fullSize}>
        <plume.styles.heading.S asDesktop="L">
          <plume.illustrations.twoToned.CrackedEgg size={60} noBackground inverted />

          {t('%(name)s got funded!', { name: model.user.username(project.owner) })}
        </plume.styles.heading.S>

        <plume.styles.copy.M>
          {t('Discover more %(mainTag)s live projects 👇', {
            mainTag: model.project.mainTag<projectModel.ExtraFields>(project),
          })}
        </plume.styles.copy.M>

        <plume.styles.button.Button size="medium" kind="primary" as="a" href={project.main_tag?.absolute_url}>
          {t(`See all %(category)s projects`, {
            category: project.main_tag?.name[userConfig.lang],
          })}
        </plume.styles.button.Button>
      </InformationContainer>
    </ProjectFinancedContainer>
  )
}

const ProjectFinancedContainer = styled.div<{ fullSize: boolean }>`
  display: block;
  text-align: center;
  padding: 20px 0;
  width: 100%;

  // NOT SCREEN !
  @media not screen and ${plume.BREAKPOINTS.LAPTOP} {
    ${plume.illustrations.Illustration} {
      margin-bottom: 5px;
    }
  }

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    display: flex;
    padding: 0;
    max-width: 790px;

    ${({ fullSize }) => {
      if (fullSize) {
        return css`
          justify-content: center;
        `
      } else {
        return css`
          text-align: left;
        `
      }
    }}
  }
`

const InformationContainer = styled.div<{ fullSize: boolean }>`
  box-sizing: border-box;
  padding: 0 20px;
  width: 100%;

  ${({ fullSize }) => {
    if (fullSize) {
      return css`
        align-items: center;
        display: flex;
        flex-direction: column;
      `
    }
  }}

  ${plume.styles.heading.S} {
    align-items: center;
    display: flex;
    margin-bottom: 6px;
  }

  ${plume.styles.button.Button} {
    width: 100%;
  }

  ${plume.styles.copy.M} {
    margin-bottom: 20px;
  }

  // NOT SCREEN !
  @media not screen and ${plume.BREAKPOINTS.LAPTOP} {
    ${plume.styles.heading.S} {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-bottom: 0px;
    }
  }

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    ${plume.styles.heading.S} {
      ${plume.illustrations.Illustration} {
        margin-right: 8px;
      }
    }

    ${plume.styles.button.Button} {
      width: auto;
    }
  }
`
